import './tmacs/style';
import FormStructure from './tmacs/form_structure';

export default FormStructure;